import * as actionTypes from "./actionTypes";

export const addLicenseAction = (licenseData) => {
  return { type: actionTypes.ADD_LICENSE, licenseData };
};

export const addLicenseSuccessAction = (licenses) => {
  return { type: actionTypes.ADD_LICENSE_SUCCESS, licenses };
};

export const editLicenseAction = (licenseData) => {
  return { type: actionTypes.EDIT_LICENSE, licenseData };
};

export const editLicenseSuccessAction = (licenses) => {
  return { type: actionTypes.EDIT_LICENSE_SUCCESS, licenses };
};

export const deleteLicenseAction = (licenseData) => {
  return { type: actionTypes.DELETE_LICENSE, licenseData };
};

export const deleteLicenseSuccessAction = (licenses) => {
  return { type: actionTypes.DELETE_LICENSE_SUCCESS, licenses };
};

export const getLicensesAction = (storeId) => {
  return { type: actionTypes.GET_LICENSES, storeId };
};

export const getLicensesSuccessAction = (licenses) => {
  return { type: actionTypes.GET_LICENSES_SUCCESS, licenses };
};
